import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import { LAW_TABS } from '@platform/engine/tabs/lawdesigner/lawTabs';
import { useListRecordsQuery } from '@platform/state/api';
import { EmptyState, ErrorBanner, Spinner } from '@platform/ui';
import type { IModulePageProps } from '../IModulePageProps';

/**
 * «Візуальна модель закону» конструктора законопроєктів (прототип v4 mnLawModel, ключ сторінки `lawmodel`): окремої сторінки немає —
 * відкривається перший законопроєкт (найменший номер) на вкладці «Структура» візуальної моделі (заміною в історії). Без записів —
 * порожній стан.
 */
export function LawModelPage({ ws, module, rt }: IModulePageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading, error } = useListRecordsQuery({ ws, rt: rt.key, params: { sort: 'code', pageSize: 10, facets: false } });
  const first = data?.items[0];
  useEffect(() => {
    if (first) navigate(routes.record(module.module.key, rt.key, first.id, LAW_TABS[0]), { replace: true });
  }, [first, navigate, ws, module.module.key, rt.key]);
  if (error) return <ErrorBanner error={error} />;
  if (isLoading || first) return <Spinner />;
  return <EmptyState icon="network" text={t('modBody.lawModelEmpty')} />;
}
